import { useQuery, useMutation } from "@tanstack/react-query";
import api from "../axios-client";
import { queryClient } from "../query-client";

export const useGetEmailTemplates = () => {
    return useQuery({
        queryKey: ["email-templates"],
        queryFn: async () => {
            const response = await api.get("/api/v1/email-templates");
            return response.data.data;
        },
        staleTime: 1000 * 60 * 60,
    });
};

export const useUpdateEmailTemplate = () =>
    useMutation({
        mutationFn: async ({ slug, subject, body }: { slug: string; subject: string; body: string }) => {
            const response = await api.put(`/api/v1/email-templates/${slug}`, { subject, body });
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["email-templates"] });
        },
    });

export const useResetEmailTemplate = () =>
    useMutation({
        mutationFn: async (slug: string) => {
            const response = await api.delete(`/api/v1/email-templates/${slug}`);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["email-templates"] });
        },
    });
